let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("1zPhe")).then(() => parcelRequire('3OR5W'));